import { useEffect, useRef, useState } from "react";
import {
  Modal,
  Form,
  Container,
  Content,
  Button,
  Schema,
  Loader,
  SelectPicker,
  Input,
  FlexboxGrid,
  DatePicker,
} from "rsuite";
import { updateIn } from "json-immut";
import { StringType, NumberType } from "schema-typed";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { UserServices } from "../../../core/services/UserServices";
import { useSelector } from "react-redux";
import { get } from "lodash/fp";
import {
  dateFormatObj,
  messageTypeArr,
  orderStatusObj,
  orderStatusObjArr,
  roleTypeArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import React from "react";
import { isNotEmpty } from "../../../utils/helpers";
import moment from "moment";
import OrderServiceServedItems from "./OrderServiceServedItems";
import { OrderServices } from "../../../core/services/OrderServices";

const Textarea = React.forwardRef((props: any, ref: any) => (
  <Input {...props} as="textarea" ref={ref} />
));

const ServeOrder = ({
  openModal,
  setOpenModal,
  orderObj,
  onServeOrder,
}: {
  openModal: boolean;
  setOpenModal: any;
  orderObj: any;
  onServeOrder: Function;
}) => {
  const { t } = useTranslation();
  const userActionData = useSelector((state: any) => {
    return state?.actionData?.id;
  });
  const formRef = useRef<any>();

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [servedByList, setServedByList] = useState([]);
  const [formError, setFormError] = useState<any>({});
  const [orderInfo, setOrderInfo] = useState<any>({});
  const [showServiceDetails, setShowServiceDetails] = useState(false);
  const toggleServiceDetails = () => setShowServiceDetails(!showServiceDetails);
  const [orderServiceItems, setOrderServiceItems] = useState<any[]>([]);
  const [formData, setFormData] = useState({
    order_status: orderStatusObj.served.value,
    served_by: isNotEmpty(orderObj?.served_by)
      ? orderObj?.served_by
      : orderObj?.order_assigned_to,
    manager_feedback: orderObj?.manager_feedback,
    served_at: isNotEmpty(orderObj?.served_at)
      ? new Date(
          moment(orderObj?.served_at).format(dateFormatObj.moment_y_m_d_h_m),
        )
      : new Date(moment().format(dateFormatObj.moment_y_m_d_h_m)),
    follow_up_date: isNotEmpty(orderObj?.follow_up_date)
      ? new Date(
          moment(orderObj?.follow_up_date).format(dateFormatObj.moment_y_m_d),
        )
      : null,
    notes: orderObj?.notes,
  });
  const [loader, setLoader] = useState(false);
  async function getViewOrderDetail(id: number) {
    try {
      setLoader(true);
      const res = await OrderServices.viewOrder(id);
      const orderData = get("data.data", res);
      setLoader(false);
      if (orderData) {
        setOrderInfo({ ...orderData });
        setOrderServiceItems(orderData.order_service_items);
      }
    } catch (error) {
      setLoader(false);
    }
  }
  useEffect(() => {
    getViewOrderDetail(orderObj.id);
  }, []);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }

  const handleServiceItemChange = (updatedItems: any[]) => {
    setOrderServiceItems([...updatedItems]);
  };
  async function servedBySearch(searchStaff: string) {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = orderObj.company_id;
    }

    if (!compId) {
      return;
    }
    try {
      const res = await UserServices.getStaffList({
        company: compId.toString(),
        smart_search: searchStaff,
        rows: 1000,
      });
      const respData = get("data.data", res);
      if (respData.length) {
        setServedByList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }
  const formModel = Schema.Model({
    manager_feedback: StringType(),
  });

  async function updateOrder(orderId: number, payload: any) {
    try {
      setLoader(true);
      if (onServeOrder) onServeOrder(orderId, payload);
      setLoader(false);
      setOpenModal("");
    } catch (error: any) {
      setLoader(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
    }
  }

  const orderChangeSubmitted = () => {
    let formFields: any = { ...formData };
    let payload = {
      order_status: formFields["order_status"],
      manager_feedback: formFields["manager_feedback"],
      served_at: formFields["served_at"],
      served_by: formFields["served_by"],
      follow_up_date: formFields["follow_up_date"],
      notes: formFields["notes"],
      service_items: JSON.stringify(orderServiceItems),
    };
    updateOrder(+orderObj.id, payload);
  };

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex as keyof typeof frmObj] = date;
    setFormData({ ...frmObj });
  };

  useEffect(() => {
    servedBySearch("");
  }, []);

  return (
    <div className="modal-container">
      <Modal
        open={openModal}
        backdrop={true}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="sm"
      >
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            backdrop
            content={t("LOADING")}
            vertical
          />
        )}
        <Modal.Header>
          <h4>
            {t("SERVE")} {t("ORDER")} {t("FOR")} <b>{orderObj.customer_name}</b>
            {" ("}
            <b>{orderObj.customer_phone}</b>
            {" )"}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Content className="edit-cnt mt-1 content mt-2 pt-0">
              <Form
                layout="inline"
                ref={formRef}
                model={formModel}
                className="serv-rdo"
                formError={formError}
                formDefaultValue={formData}
                onCheck={(e: any) => {
                  setFormError(e);
                }}
                onSubmit={(e: any) => {
                  if (e) {
                    orderChangeSubmitted();
                  }
                }}
                onChange={(data: any) => {
                  setFormData(data);
                }}
              >
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item className="cst-fdbk-bx">
                    <Form.Group>
                      <FlexboxGrid.Item>
                        <Form.Group>
                          <Form.ControlLabel>
                            {t("STATUS") +
                              " " +
                              orderStatusObj[
                                orderObj.order_status as keyof typeof orderStatusObj
                              ].label +
                              " " +
                              t("TO")}
                          </Form.ControlLabel>
                          <SelectPicker
                            data={orderStatusObjArr.filter(
                              (item) =>
                                item.value != orderStatusObj.cancelled.value &&
                                item.value != orderObj.order_status,
                            )}
                            valueKey="value"
                            labelKey="label"
                            onSelect={(value, item) => {
                              handleFormChanges({
                                path: "order_status",
                                value,
                              });
                            }}
                            onClean={(e: any) => {
                              handleFormChanges({
                                path: "order_status",
                                value: "",
                              });
                            }}
                            name="order_status"
                            value={formData?.order_status}
                            size="sm"
                          />
                        </Form.Group>
                      </FlexboxGrid.Item>
                      <Form.ControlLabel>
                        {t("MAJOR")} {t("SERVICE")} {t("BY")}
                      </Form.ControlLabel>
                      <SelectPicker
                        data={servedByList}
                        valueKey="id"
                        labelKey="name"
                        onSelect={(value, item) => {
                          handleFormChanges({ path: "served_by", value });
                        }}
                        onClean={(e: any) => {
                          handleFormChanges({
                            path: "served_by",
                            value: "",
                          });
                        }}
                        name="served_by"
                        value={formData?.served_by}
                        size="sm"
                      />
                    </Form.Group>
                    <Form.Group controlId="served_at">
                      <Form.ControlLabel>
                        {t("SERVICE")} {t("DATE")}
                      </Form.ControlLabel>
                      <DatePicker
                        value={formData?.served_at}
                        format={dateFormatObj.calendar_d_m_y_h_m}
                        name="served_at"
                        id="served_at"
                        onChange={(e: any) => {
                          handleDateChange(e, "served_at");
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item className="cst-fdbk-bx">
                    <Form.Group controlId="manager_feedback">
                      <Form.ControlLabel>
                        {t("MANAGER")} {t("FEEDBACK")}
                      </Form.ControlLabel>
                      <Form.Control
                        name="manager_feedback"
                        rows={9}
                        accepter={Textarea}
                        onChange={(e: any) => {
                          handleFormChanges({
                            path: "manager_feedback",
                            value: e,
                          });
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item className="cst-fdbk-bx">
                    <Form.Group controlId="follow_up_date">
                      <Form.ControlLabel>
                        {t("NEXT")} {t("ORDER")} {t("DATE")}
                      </Form.ControlLabel>
                      <DatePicker
                        value={formData?.follow_up_date}
                        format={dateFormatObj.calendar_d_m_y}
                        name="follow_up_date"
                        id="follow_up_date"
                        onChange={(e: any) => {
                          handleDateChange(e, "follow_up_date");
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                  <FlexboxGrid.Item className="cst-fdbk-bx">
                    <Form.Group controlId="notes">
                      <Form.ControlLabel>
                        {t("NEXT")} {t("ORDER")} {t("NOTE")}
                      </Form.ControlLabel>
                      <Form.Control
                        name="notes"
                        rows={2}
                        accepter={Textarea}
                        onChange={(e: any) => {
                          handleFormChanges({
                            path: "notes",
                            value: e,
                          });
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>
                <div className="usr-form-btn mt-0">
                  {showServiceDetails && (
                    <>
                      <div
                        className="address-bx"
                        onClick={toggleServiceDetails}
                      >
                        <h5>
                          {t("SERVICE")} {t("ITEMS")} {t("SERVED")} {t("BY")}
                        </h5>
                      </div>
                      <OrderServiceServedItems
                        orderServiceItems={orderServiceItems}
                        servedByList={servedByList}
                        onServiceItemChange={handleServiceItemChange}
                      />
                    </>
                  )}
                </div>
                <div className="usr-form-btn mt-0">
                  <Form.Group>
                    <Button
                      appearance="primary"
                      onClick={(e: any) => setIsFormSubmitted(true)}
                      type="submit"
                    >
                      {t("UPDATE")}
                    </Button>
                    <Button
                      style={{ marginLeft: "10px" }}
                      onClick={(e: any) => {
                        setIsFormSubmitted(false);
                        setOpenModal("");
                      }}
                      appearance="primary"
                      color="red"
                      type="reset"
                    >
                      {t("CLOSE")}
                    </Button>
                    <Button
                      appearance="primary"
                      color="green"
                      type="button"
                      style={{ marginLeft: "10px" }}
                      onClick={toggleServiceDetails}
                    >
                      {showServiceDetails ? t("HIDE") : t("SHOW")}
                      {" " + t("SERVICE") + " " + t("DETAILS")}
                    </Button>
                  </Form.Group>
                </div>
              </Form>
            </Content>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ServeOrder;
